import React from 'react';

import AuthContext from './AuthContext';

export const useAuthContext = () => {
  const authContext = React.useContext(AuthContext);
  return { ...authContext };
};
